import React from 'react'
import CardLayout from '../../layouts/CardLayout'
import WebsiteIcon from '../../icons/WebsiteIcon'
import { Text } from '../../../modules/Dashboard'
import LeftIcon from '../../icons/Left'
import { ReactComponent as TelegramVector } from '../../../assets/images/trading-pro/telegram-vector.svg';
import SendIcon from '../../icons/SendIcon'
import { Link } from 'react-router-dom'

const NewsCard = () => {
    return (
        <div className='flex flex-col lg:flex-row rtl:lg:flex-row-reverse items-center gap-5'>
            <CardLayout className=" w-full lg:w-4/5 p-4">
                <div className='flex items-start sm:items-center flex-col sm:flex-row gap-2 w-full'>
                    <span className='inline-block'>
                        <WebsiteIcon size={20} className="inline mx-1" />
                        <Text tid="news" />
                    </span>
                    <Link to="/assistant/suggestions?step=assistant" className=' ltr:ml-auto rtl:mr-auto'>
                        <span className='inline-block'>
                            <Text tid="try-it" className='!text-primaryOrange   font-semibold' />
                            <LeftIcon color='#fc6432' className="ltr:rotate-180 inline mx-1" />
                        </span>
                    </Link>
                </div>
            </CardLayout>
            <CardLayout className=" w-full lg:w-1/5 p-4 cursor-pointer" onClick={() => window.open('https://t.me/candlive', '_blank')}>
                <div className='flex items-center gap-2 w-full justify-center'>
                    <SendIcon color='#fc6432' className="rotate-90" size={20} />
                    <Text tid={"join-the-telegram"} className='!text-primaryOrange  font-semibold' />
                </div>
            </CardLayout>
        </div>
    )
}

export default NewsCard